export default {
  ctrlCaption: "流程信息",
  props: {
    caption: {
      type: String,
      default() {
        return "wfinfo";
      },
    },
    chooseFlow: {
      type: Object,
      default() {
        return {};
      },
    },
    sWFID: {
      type: String,
      default() {
        return "";
      },
    },
    sObjectID: {
      type: String,
      default() {
        return "";
      },
    },
    sObjectName: {
      type: String,
      default() {
        return "";
      },
    },
    sPID: {
      type: String,
      default() {
        return "";
      },
    },
    sCurLinkID: {
      type: String,
      default() {
        return "";
      },
    },
    sCurNodeID: {
      type: String,
      default() {
        return "";
      },
    },
    sOpinion: {
      type: String,
      default() {
        return "";
      },
    },
    sExInfos: {
      type: String,
      default() {
        return "";
      },
    },
    sLineIDs: {
      type: String,
      default() {
        return "";
      },
    },
    sReceivers: {
      type: String,
      default() {
        return "";
      },
    },
    eventName: {
      type: String,
      default() {
        return "";
      },
    },
    countDown: {
      type: String,
      default() {
        return "3";
      },
    },
    linkData: {
      type: Array,
      default() {
        return [];
      },
    },
    forceHidden: {
      type: Boolean,
      default: true
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("flow-info-meta-data");
      },
    },
  },
  data() {
    return {
      _RequestID: null,
      flowSendOverEvent: "",
      owner: null,
      dialog: null,
      isFristSend: false,
      BackLineID: "",
      currLineID: '',
      Objects: {},
      receivers: ''
    };
  },
  watch: {
    chooseFlow(val) {
      const value = {
        wf_id: val.ID,
        wf_name: val.name,
      };
      this.emitValueChange(value);
    },
  },
  computed: {},
  mounted() {
    if (this.$vm && this.$vm.flows) {
      this.$vm.flows.flowInfo = this;
    }
  },
  destroyed() { },
  methods: {
    getCurrLinkID(Objects) {
      const sCurLinkID = this.$replace(this.sCurLinkID, this.$vm);
      return sCurLinkID || Objects?.sCurLinkID || this.$route.query?.sCurLinkID || this.queryString?.sCurLinkID
    },
    linkSetChooseFlow() {
      document.querySelector("[rel='linkData'] .ds-button")?.click();
    },
    flowSend(res, targetButton, owner, Objects) {
      const { line, flowSendOverEvent, completed, IsSPSend } = targetButton;
      this.dialog = null;
      this.flowSendOverEvent = flowSendOverEvent;
      this.owner = owner;
      this.Objects = Objects;
      // 流程发送按钮
      let sWFID = this.chooseFlow.dsfa_rm_id;
      if (sWFID) {
        const sObjectName = this.$replace(this.sObjectName, this.$vm);
        sWFID = this.$replace(this.sWFID, this.$vm) || sWFID;
        const sCurNodeID = this.$replace(this.sCurNodeID, this.$vm);
        const sPID = this.$replace(this.sPID, this.$vm);
        let sOpinion = this.$replace(this.sOpinion, this.$vm);
        let sLineIDs = this.$replace(this.sLineIDs, this.$vm);
        let sObjectID = this.$replace(this.sObjectID, this.$vm);
        let sExInfos = this.$replace(this.sExInfos, this.$vm);
        let sReceivers = this.$replace(this.sReceivers, this.$vm);
        sExInfos = !sExInfos ? '' : eval('(' + sExInfos + ')');
        sOpinion = !sOpinion ? '' : eval('(' + sOpinion + ')');
        sLineIDs = !sLineIDs ? '' : eval('(' + sLineIDs + ')');
        // 增加 sExInfos
        sExInfos = sExInfos || Object.assign({}, dsf.removePoint(this.$vm.$viewData), this.$route.query);
        let ds_security_level;
        for(let key in this.$vm.$viewData) {
          if(key?.indexOf(".ds_security_level") > -1) {
            ds_security_level = this.$vm.$viewData?.[key];
          }
        }
        // return;
        // 开始发送
        let url = IsSPSend ? "wfr/startSPSend" : "wfr/startSend",
          param = {
            sWFID: sWFID,
            sObjectID: sObjectID || res._id,
            sObjectName: sObjectName || this.$vm.$refs[this.eventName]?.value || "",
            sCurNodeID: sCurNodeID || "",
            sExInfos: JSON.stringify(sExInfos),
            sReceivers: sReceivers,
            securityClassValue: ds_security_level?.value,
            securityLevelExpiryDate: ds_security_level?.expirydate
          };
        //继续发送
        if (Objects || this.$route.query.sPID || this.queryString.sPID) {
          url = IsSPSend ? "wfr/spSend" : "wfr/send";
          param = {
            sPID: sPID || Objects?.sPID || this.$route.query?.sPID || this.queryString?.sPID,
            sCurLinkID: this.getCurrLinkID(this.Objects),
            sExInfos: JSON.stringify(sExInfos),
            sReceivers: sReceivers,
            securityClassValue: ds_security_level?.value,
            securityLevelExpiryDate: ds_security_level?.expirydate
          };
          this.isFristSend = false;
        } else {
          this.isFristSend = true;
        }

        if (sOpinion) {
          param.sOpinion = JSON.stringify(sOpinion);
        } else {
          // 发送时有处理意见
          if (this.$vm?.flows?.disposeIdea?.sOpinion) {
            param.sOpinion = JSON.stringify(this.$vm.flows.disposeIdea.sOpinion);
          }
          // 发送时表单意见框有处理意见
          if (this.$vm?.flows?.sOpinion?.Content || this.$vm?.flows?.sOpinion?.Attachments?.length > 0) {
            param.sOpinion = JSON.stringify(this.$vm.flows.sOpinion);
          }
        }
        if (sLineIDs) {
          param.sLineIDs = sLineIDs;
        } else {
          if (line) {
            param.sLineIDs = line.LineID;
          }
        }
        this.currLineID = param.sLineIDs;

        const config = {
          param: param,
          url: url,
        };

        this.$http
          .post(config.url, config.param)
          .then((response) => {
            this.handler(response, false, completed);
          })
          .catch((res) => {
            console.error(res);
            this.$message("发送异常", false);
            this._RequestID = null;
          })
          .finally(() => {
            // 防止网络请求很快的情况
            setTimeout(() => {
              targetButton.disabled = false;
            }, 1000);
          });
      } else {
        this.$message("请先配置流程信息控件的'选择流程'", false);
      }
    },
    handler(response, isShowBack, completed) {
      if (this.dialog) {
        this.dialog.close();
        this.dialog = null;
      }
      if (response.data.state == 20000) {
        let data = response.data.data;
        this._RequestID = data.RequestID;
        if (data.Code == 20000 || data.Code == 20001 || data.Code == 20003 || data.Code == 20004 || data.Code == 20005) {
          // 发送成功 || 发送到汇总节点 || 发送到汇总环节并激活汇总环节 || 办结当前节点 || 办结当前节点，并办结整个流程
          if (this.flowSendOverEvent) {
            this.owner.$dispatch(this.flowSendOverEvent, data);
          } else {
            this.directlySend(data, completed);
          }
        } else if (data.Code == 81000) {
          // 或选择
          this.chooseSendNode(data);
        } else if (data.Code == 82000) {
          // 与选择
          this.chooseSendTree(data, isShowBack);
        } else if (data.Code == 82001) {
          // 自由流
          this.chooseFreedom(data);
        } else if (data.Code == 83000) {
          // 密级可以继续发送
          this.security(data, true);
        } else if (data.Code == 97000) {
          // 密级不可以继续发送
          this.security(data, false);
        } else {
          let msg = data.Message;
          if (data.EsMessage) {
            msg = msg + "." + data.EsMessage;
          }
          this.$message(msg || "未知流程类型发送", false);
        }
      } else {
        let data = response.data;
        this._RequestID = null;
        let msg = data?.data?.Message || data.message;
        if (data.EsMessage) {
          msg = msg + "." + data.EsMessage;
        }
        this.$message(msg || "发送异常", false);
      }
    },
    security(data, isSend) {
      let length = data?.warnUserNames?.length;
      let warnUserNames = data?.warnUserNames?.join("、");
      if (length > 20) {
        warnUserNames = data.warnUserNames.splice(0, 20).join("、");
      }
      dsf.layer.openDialog({
        title: "<div class='flow-security-title'><i class='el-alert__icon el-icon-warning'></i><span>提示</span></div>",
        width: "440px",
        height: "auto",
        customClass: 'flow-security',
        template: `<div>
            <span class="user">${warnUserNames || ''}</span>
            <span>${length > 20 ? '等' + length : ''}用户密级过低，不能处理此任务${isSend ?'，是否继续发送？': ''}</span>
          </div>`,
        btns: [
          {
            text: "仍发送",
            class: { hide: !isSend },
            handler: (component) => {
              let result = [];
              let Lines = data.SendParams.Lines;
              Lines = Lines.filter(item => item.Selected);
              Lines.forEach(line => {
                line?.Receivers?.Dept?.Objs?.forEach(obj => {
                  result.push(`${line.LineID}:${obj.ID}`);
                });
              });
              this.sendToReceivers(this.receivers || result.join(";"), data.RequestID, 1);
              return true;
            },
          },
          {
            text: "取消",
          },
        ],
      });
    },
    directlySend(data, completed) {
      let list = [],
        _this = this;
      if (data.Code == 20000 || data.Code == 20001 || data.Code == 20003) {
        data.Links.forEach((line, index) => {
          if ((line.Status == 0 || line.Status == -2) && line.LinkUser) {
            let linkUser = line.LinkUser;
            let type = line.LinkUser.Type;
            if (type == 1) {
              // 直接选人
              list.push(linkUser.UserName);
            } else if (type == 2 && linkUser.DeptID != '-1') {
              let DeptName = linkUser.DeptName;
              // let GlobalDeptName = linkUser.GlobalDeptName.split(",");
              // let DeptName = GlobalDeptName.length >= 3 ? GlobalDeptName[2] : linkUser.DeptName;
              // 部门+角色
              list.push(`${DeptName}-${linkUser.RoleName}`);
            } else if (type == 3) {
              // 岗位
              list.push(linkUser.JobName);
            } else if (type == 4) {
              // 人+关系
              list.push(`${linkUser.UserName}-${linkUser.RelationName}`);
            } else if (type == 5) {
              // 机器人
              list.push(linkUser.RobotName);
            }
          }
        });
        this.$openDialog({
          type: "dialog",
          title: "流程已发送到以下人员：",
          width: "320px",
          height: "auto",
          overflow: "auto",
          content: "SendFlowDialog",
          footerAlign: "center",
          showClose: false,
          params: {
            list: _.uniq(list),
            countDownTime: this.countDown,
          },
          btns: [
            {
              text: "确定",
              class: `sendFlow ${dsf.global.$isMobile ? "van-dialog__confirm" : ""}`,
              handler: (component) => {
                this.closeOpener();
                return true;
              },
            },
          ],
        });
      } else {
        let msg = "发送成功",
          code = data.Code;
        switch (code) {
        case 20004:
        case 20005:
          msg = completed ? this.$replace(completed, this.$expressParams(data)) : "文件已办结";
          break;
        }
        this.$openDialog({
          type: "dialog",
          title: "提示",
          width: "300px",
          height: "120px",
          content: "SendFlowDialog",
          footerAlign: "center",
          showClose: false,
          params: {
            msg: msg,
            countDownTime: this.countDown,
          },
          btns: [
            {
              text: "确定",
              class: `sendFlow ${dsf.global.$isMobile ? "van-dialog__confirm" : ""}`,
              handler: (component) => {
                this.closeOpener();
                return true;
              },
            },
          ],
        });
      }
    },
    chooseFreedom(data) {
      let lines = data.SendParams.Lines;
      const currLineID = this.currLineID;
      let line = lines.length > 1 ? lines.filter(c => c.LineID == currLineID)?.[0] : lines[0];
      if (!line) {
        return;
      }
      let sWFID = this.chooseFlow.dsfa_rm_id;
      sWFID = this.$replace(this.sWFID, this.$vm) || sWFID;
      let btns = [
        {
          text: "确定",
          handler: (component) => {
            if (component.$refs.view.validate()) {
              const loadingIndex = dsf.layer.loading();
              const result = component.$refs.view.yes();
              this.receivers = result.sReceivers;
              this.sendToReceivers(result.sReceivers, this._RequestID, '', loadingIndex);
              return true;
            }
            return false;
          },
        }
      ];
      if (dsf.global.$isMobile) {
        btns.unshift({
          text: "取消",
        });
      }
      this.$openDialog({
        showClose: !dsf.global.$isMobile,
        fullscreen: dsf.global.$isMobile,
        title: "选择发送对象",
        width: dsf.global.$isMobile ? "100vw" : "1050px",
        height: dsf.global.$isMobile ? "100vh" : "calc(85vh - 120px)",
        btnPosition: "bottom",
        params: {
          wfId: sWFID,
          line: line,
          curLinkId: this.getCurrLinkID(this.Objects),
          path: dsf.global.$isMobile ? "#/mobile/dsfa/flow/freedom/mobile-index" : "/dsfa/flow/freedom/index",
        },
        btns: btns
      });
    },
    // getSendBackLink(args, targetButton) {
    //   let param = {
    //     sPID: args[0] || null,
    //     sCurLinkID: args[1] || null,
    //   };
    //   this.$http
    //     .post("wfr/getSendBackLink", param)
    //     .then((res) => {
    //       if (res.data.success && res.data.data && res.data.data.BackLinks) {
    //         let BackLinks = res.data.data.BackLinks;
    //         if (BackLinks.length == 1) {
    //           this.sendBack(args, BackLinks[0].ID);
    //         } else {
    //           this.chooseBackNode(BackLinks, args);
    //         }
    //       } else {
    //         this.$message(res.data.data.Message || "退回异常", false);
    //       }
    //     })
    //     .catch((res) => {
    //       this.$message("退回异常", false);
    //     })
    //     .finally(() => {
    //       // dsf.layer.close(loadingIndex);
    //       // 防止网络请求很快的情况
    //       setTimeout(() => {
    //         targetButton.disabled = false;
    //       }, 200);
    //     });
    // },
    // validateInput (input) {
    //   if (input && input.length >= 1000) {
    //     return '退回意见长度不能超过1000';
    //   }
    //   return true;
    // },
    // sendBack(args, id) {
    //   dsf.layer
    //     .prompt({
    //       message: "退回原因",
    //       inputPlaceholder: "请输入退回原因",
    //       inputType: "textarea",
    //       inputPattern: /\S/,
    //       inputErrorMessage: "退回原因不能为空",
    //       confirmButtonText: "确定",
    //       inputValidator: this.validateInput()
    //     })
    //     .then(({ value }) => {
    //       if(value && value.length >= 1000) {
    //         this.$message("退回意见长度不能超过1000", false);
    //         return false;
    //       }
    //       let param = {
    //         sPID: args[0] || null,
    //         sCurLinkID: args[1] || null,
    //         sReason: value || null,
    //         sBackLinkID: id,
    //       };
    //       this.$http
    //         .post("wfr/sendBack", param)
    //         .then((res) => {
    //           if (res.data.success && res.data.data && res.data.data.Code == "21000") {
    //             this.$message("退回成功", true);
    //             this.closeOpener();
    //           } else {
    //             this.$message(res.data.data.Message || "退回异常", false);
    //           }
    //         })
    //         .catch((res) => {
    //           this.$message("退回异常", false);
    //         });
    //     });
    // },
    // 选择退回节点
    // chooseBackNode(data, args) {
    //   const chooseNode = dsf.global.$isMobile ? (line)=> {
    //     this.sendBack([line.PID, args[1]], line.ID)
    //   } : dsf.noop;
    //   const hideHeader = dsf.global.$isMobile;
    //   this.$openDialog({
    //     type: "dialog",
    //     title: "请选择要退回的环节：",
    //     width: "300px",
    //     height: "auto",
    //     overflow: "auto",
    //     footerAlign: "center",
    //     content: (dsf.global.$isMobile ? "DsfMobile" : "") + "ChooseSendNode",
    //     params: {
    //       lines: data,
    //       chooseNode: chooseNode,
    //       hideHeader: hideHeader,
    //       callback: (arr, id) => { this.sendBack([arr[0], args[1]], id) },
    //       requestID: this._RequestID,
    //       type: "back",
    //     },
    //     btns: [
    //       {
    //         class: `close-send-node ${dsf.global.$isMobile ? "van-dialog__cancel" : ""}`,
    //         text: "取消",
    //         handler: () => {
    //           this.dialog = null;
    //           return true;
    //         },
    //       },
    //     ],
    //   });
    // },
    chooseSendNode(data) {
      let btns = [];
      if (data.SendParams.Lines && data.SendParams.Lines[0] && data.SendParams.Lines[0].SendToLineID) {
        btns.push({
          text: "返回",
          class: "plain",
          handler: (component) => {
            let param = {
              sRequestID: this._RequestID,
              sLineID: data.SendParams.Lines && data.SendParams.Lines[0] && data.SendParams.Lines[0].BackLineID,
            };
            this.$http.post("wfr/setLineToBack", param).then((res) => {
              this.handler(res);
            });
            return true;
          },
        });
      }
      this.dialog = dsf.layer.openDialog({
        title: "请选择要发送的环节：",
        width: "400px",
        height: "auto",
        overflow: "auto",
        footerAlign: "center",
        content: "ChooseSendNode",
        params: {
          title: "请选择要发送的环节：",
          lines: data.SendParams.Lines,
          callback: (res, isShowBack, line) => {
            this.currLineID = line.LineID;
            this.handler(res, isShowBack)
          },
          requestID: this._RequestID,
          type: "next",
        },
        btns: btns,
      });
    },
    chooseSendTree(data, isShowBack) {
      let lines = data.SendParams.Lines;
      const LineID = lines.map(c => c.LineID).join();
      this.dialog = this.$openDialog({
        title: "请选择办理人",
        width: "900px",
        height: "420px",
        overflow: "hidden",
        content: "ChooseSendTree",
        params: {
          lines: lines,
        },
        btns: [
          {
            text: "返回",
            type: 'plain',
            class: `choose-send-node ${isShowBack ? "" : "hide"}`,
            handler: (component) => {
              let param = {
                sRequestID: this._RequestID,
                sLineID: data.SendParams.Lines && data.SendParams.Lines[0] && data.SendParams.Lines[0].SendToLineID,
              };
              this.$http.post("wfr/setLineToBack", param).then((res) => {
                this.handler(res);
              });
              return true;
            },
          },
          {
            text: "选择模板",
            class: dsf.global.$isMobile ? "hide" : "",
            handler: (component) => {
              let param = {
                sLineIDs: LineID,
              };
              this.$http.post("wfr/getHandlerTemplateList", param).done((res) => {
                if (res.success) {
                  const data = res.data;
                  data.forEach(item => {
                    item.id = item.dsfa_wf_link_handler_template;
                    item.label = item.template_name
                  });
                  this.$openDialog({
                    title: "选择模板",
                    width: "330px",
                    height: "420px",
                    overflow: "hidden",
                    content: "DsfFlowSelectTree",
                    params: {
                      treeData: data,
                      showDel: true,
                      delUrl: "wfr/delHandlerTemplate"
                    },
                    btns:[
                      {
                        text: "确定",
                        handler: (com) => {
                          let nodes = com.$refs.treeForm.getCheckedNodes();
                          nodes = nodes.filter((node) => !node.disabled);
                          let ids = [];
                          for (const node of nodes) {
                            let receivers = node.receiver.split(";");
                            for (const receiver of receivers) {
                              ids.push(...receiver.replace(/.*\:/, "").split(","));
                              const rec = receiver.split(":");
                              const LineID = rec[0];
                              for (const line of  component.linesData) {
                                if (line.LineID === LineID) {
                                  line.checked = rec[1].split(",");
                                }
                              }
                            }
                          }
                          return true;
                        },
                      },
                    ]
                  });
                }
              });
              return false;
            },
          },
          {
            text: "保存模板",
            class: dsf.global.$isMobile ? "hide" : "",
            handler: (component) => {
              if (component.validate()) {
                dsf.layer
                  .prompt({
                    message: "模板名称",
                    inputPlaceholder: "请输入模板名称",
                    inputType: "input",
                    inputPattern: /\S/,
                    inputErrorMessage: "模板名称不能为空",
                    confirmButtonText: "确定",
                    inputValidator: (input) => {
                      if (input && input.length > 50) {
                        return '模板名称长度不能超过50';
                      }
                      return true;
                    },
                  })
                  .then(({ value }) => {
                    const result = component.yes();
                    let param = {
                      templateName: value,
                      sLineIDs: LineID,
                      sReceivers: result,
                    };
                    this.$http.post("wfr/saveHandlerTemplate", param).done((res) => {
                      if (res.success) {
                        this.$message("保存成功", true);
                      } else {
                        this.$message(res.message, false);
                      }
                    });
                  });
                return false;
              }
              return false;
            },
          },
          {
            text: "确定",
            type: '',
            handler: (component) => {
              if (component.validate()) {
                const result = component.yes();
                this.receivers = result;
                this.sendToReceivers(result, this._RequestID);
                document.querySelector(".close-send-node")?.click();
                return true;
              }
              return false;
            },
          },
        ],
      });
    },
    sendToReceivers(result, requestID, ignore, loadingIndex) {
      let param = {
        sRequestID: requestID,
        sReceivers: result,
        ignoreWarn: ignore
      };
      this.$http.post("wfr/sendToReceivers", param).then((res) => {
        this.handler(res);
        if (dsf.isDef(loadingIndex)) {
          dsf.layer.closeLoading(loadingIndex);
        }
      });
    },
    closeOpener() {
      if (dsf.global.$isMobile) {
        if (window.sendFlowTimer) {
          clearTimeout(window.sendFlowTimer)
          delete window.sendFlowTimer
        }
        this.$router.go(-1);
        return true;
      }
      if (this?.$vm?.$dialog) {
        this.$vm.$dialog?.openerVm?.reloadData?.(true);
        this.$vm.$dialog?.close?.();
      } else if (this?.$vm?.$openerVm) {
        this.$vm.$openerVm?.reloadData?.(true);
        this.$vm?.$closeWindow?.();
      } else if (window?.opener) {
        try {
          window.opener.reloadData?.(true);
        } catch (e) {/* ignore */}
        window.close();
      } else {
        dsf.layer.closeWindow()
      }
    }
  },
};
